import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { BaseCategory } from "@Base/Category/Category";

import "./Category.scss";

export class Category extends BaseCategory
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();
	};

	public override ConfigureSidebar(): void
	{
		return;
	}
}

export class CategoryPage extends BasePage
{
	public Category: Category;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Category = new Category();
	};
}

const category = new CategoryPage();